import { TakerMarket } from '@/enterprise/data/useTakerMarkets';

export const createTakerMarketUuidMap = (takerMarket: TakerMarket): string => {
  return `${takerMarket.marketUuid}-${takerMarket.takerDivisionUuid}`;
};

export const createTakerMarketUuidsMap = (takerMarkets: TakerMarket[]): string[] => {
  return takerMarkets.map(createTakerMarketUuidMap);
};
